import request from '@/utils/request'

const userDeliveryGarbage = {
  name: 'userDeliveryGarbage',
  state: {
    isUserDeliveryGarbageDetailLoading: false,
    userDeliveryGarbageDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_USERDELIVERYGARBAGE_DETAIL_LOADING: (state, data) => {
      state.isUserDeliveryGarbageDetailLoading = data
    },
    SET_MODULES_USERDELIVERYGARBAGE_DETAIL_DATA: (state, data) => {
      state.userDeliveryGarbageDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryUserDeliveryGarbageDetailData({ commit }, id) {
      commit('SET_IS_MODULES_USERDELIVERYGARBAGE_DETAIL_LOADING', true)
      commit('SET_MODULES_USERDELIVERYGARBAGE_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/userDeliveryGarbage/userDeliveryGarbageDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_USERDELIVERYGARBAGE_DETAIL_LOADING', false)
          commit('SET_MODULES_USERDELIVERYGARBAGE_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_USERDELIVERYGARBAGE_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetUserDeliveryGarbageDetailData({ commit }) {
      commit('SET_MODULES_USERDELIVERYGARBAGE_DETAIL_DATA', {})
    },
    setUserDeliveryGarbageDetailData({ commit }, data) {
      commit('SET_MODULES_USERDELIVERYGARBAGE_DETAIL_DATA', data)
    }
  }
}

export default userDeliveryGarbage
